window.$ = window.jQuery = require('jquery');

require('@fancyapps/fancybox');
$.fancybox.defaults.animationEffect = 'fade';
$.fancybox.defaults.loop = true;
$.fancybox.defaults.buttons = ['close'];
$.fancybox.defaults.clickContent = 'nextOrClose';
$.fancybox.defaults.margin = [0, 0];

require('./modules/agrafa.js');

global.smallScreen = false;

$(document).ready(function() {
    //do this first: check screen size
    responsive();

    //logo hover = first menu item hover
    $('.site-logo').hover(
        function() {
            $('li:first-child:not(.active) a', '#menu').addClass('hover');
        },
        function() {
            $('a.hover', '#menu').removeClass('hover');
        }
    );

    //show mobile menu
    $('.smallScreen #menu').click(function() {
        if (!$('#menu').hasClass('responsive-menu-shown', 300, 'easeOutExpo')) {
            $('#menu').toggleClass('responsive-menu-shown', 300, 'easeOutExpo');
            return false;
        }
    });
    $('.responsive-menu').click(function() {
        $('.row-offcanvas').toggleClass('active');
    });
});

$(window).resize(function() {
    responsive();
});

function responsive() {
    if ($(window).width() < 481) {
        global.smallScreen = true;
        $('body').addClass('smallScreen');
    } else {
        global.smallScreen = false;
        $('body').removeClass('smallScreen');
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/front/app.js